import React from "react"
import { graphql, useStaticQuery } from "gatsby"

const GraphImage = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(
        filter: {
          relativeDirectory: { eq: "country_report" }
          name: { eq: "graph" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)
  return <div className="mt-4 mb-4 pb-3 text-lg-center"><img src={data.allFile.edges[0].node.childImageSharp.fluid.src} alt="graph icon" /></div>
}

export default GraphImage
